import React from 'react';

interface LineArrowDownIconProps {
  size?: number;
  color?: string;
}

export const LineArrowDownIcon: React.FC<LineArrowDownIconProps> = ({ size = 24, color = '#686868' }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 9L12 17L20 9" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
